import React from "react";

import Skeleton from "src/organization/pages/project/environment/metrics/containers/Service/LargeMetric/LargeMetric.skeleton";
import MetricName from "src/organization/pages/project/environment/metrics/containers/Service/Metric/MetricName";

import { SkeletonGrid } from "./Grid.styles";

const GridSkeleton = () => {
  return (
    <SkeletonGrid>
      {[1, 2, 3, 4, 5, 6].map(i => (
        <Skeleton
          key={i}
          name={<MetricName name="" kind="grid" serviceKind="Service" />}
        />
      ))}
    </SkeletonGrid>
  );
};

export default GridSkeleton;
